<script setup>
  import { onMounted } from "vue";

  const props = defineProps({
    blok: {
      type: Object,
      default: () => ({ embed_blockquote: "" }),
    },
    centralText: Boolean,
  });

  onMounted(() => {
    // Load Twitter script if not already loaded
    if (!window.twttr && !document.querySelector('script[src="https://platform.twitter.com/widgets.js"]')) {
      const script = document.createElement("script");
      script.src = "https://platform.twitter.com/widgets.js";
      script.async = true;
      script.onload = () => {
        // Process widgets after script loads
        if (window.twttr && window.twttr.widgets) {
          window.twttr.widgets.load();
        }
      };
      document.head.appendChild(script);
    } else if (window.twttr && window.twttr.widgets) {
      // Script already loaded, just process the widgets
      window.twttr.widgets.load();
    }
  });
</script>

<template>
  <v-container
    fluid
    class="pa-0"
  >
    <v-row>
      <v-col
        v-if="centralText"
        class="v-col-12 offset-0 v-col-sm-10 offset-sm-1 v-col-md-8 offset-md-2 v-col-lg-6 offset-lg-3 mt-0 mb-6 pb-0"
      >
        <div
          class="d-flex justify-center"
          v-html="blok.embed_blockquote"
        ></div>
      </v-col>
      <v-col
        v-else
        class="v-col-12 offset-0 v-col-sm-10 offset-sm-1 v-col-md-7 offset-md-5 mt-0 mb-6 pb-0"
      >
        <div
          class="d-flex justify-center d-md-block"
          v-html="blok.embed_blockquote"
        ></div>
      </v-col>
    </v-row>
  </v-container>
</template>

<style>
  iframe {
    border: none;
  }
  iframe body {
    background-color: transparent !important;
  }

  iframe #embed-video-container {
    background-color: transparent !important;
  }
</style>
